<template>
  <div v-if="internalValue" id="applicant-cv-form">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 vs-con-table show-full-width">
        <div class="vs-con-tbody vs-table--tbody">
          <table
            class="con-tablex vs-table--content cv-table vs-table vs-table--tbody-table"
          >
            <thead class="vs-table--thead">
              <tr>
                <th width="20%">Zeitraum</th>
                <th width="20%">Art</th>
                <th width="20%">Was</th>
                <th width="20%">Wo</th>
                <th width="20%">Aktionen</th>
              </tr>
            </thead>
            <draggable v-model="internalValue" tag="tbody" @update="onSort">
              <tr
                v-for="(entry, i) in internalValue"
                :key="entry.id"
                class="tr-values vs-table--tr tr-table-state-null"
              >
                <td colspan="5">
                  <table>
                    <tr>
                      <td class="td vs-table--td" width="20%">
                        {{ formatTimeframe(entry.dateFrom, entry.dateUntil) }}
                      </td>
                      <td class="td vs-table--td" width="20%">
                        {{ entry.type ? entry.type.name : "" }}
                      </td>
                      <td class="td vs-table--td" width="20%">
                        {{ entry.position }}
                      </td>
                      <td class="td vs-table--td" width="20%">
                        {{ entry.employer }}
                      </td>
                      <td class="td vs-table--td" width="20%">
                        <feather-icon
                          icon="chevron-down"
                          svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          class="openToggler"
                          :class="{ descriptionOpen: descriptionOpen == i }"
                          @click="openDescription(i)"
                        />
                        <feather-icon
                          icon="pen"
                          svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editEntry(i, entry)"
                        />
                        <feather-icon
                          icon="trash"
                          svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="deleteEntry(i, entry)"
                        />
                      </td>
                    </tr>
                    <tr v-if="descriptionOpen == i">
                      <td
                        colspan="5"
                        class="cv-entry-description"
                        v-html="entry.description"
                      ></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </draggable>
          </table>
        </div>

        <vs-button class="mt-3" @click="sortEntries"
          >Einträge sortieren</vs-button
        >
      </div>
      <div class="vx-col w-full md:w-1/2 show-full-width">
        <ValidationObserver ref="Cv" tag="form">
          <div class="cv-entry-form">
            <div class="vx-row">
              <div class="vx-col w-full">
                <DataInput
                  v-model="currentJob"
                  type="bool"
                  class="w-full mt-4 pr-3"
                  label="Aktuelle Tätigkeit"
                  name="currentJob"
                  min="1800"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/2">
                <DataInput
                  v-model="cvForm.dateFrom"
                  required
                  type="date-dropdown"
                  class="w-full mt-4"
                  label="Datum von"
                  name="dateFrom"
                />
              </div>

              <template v-if="!currentJob">
                <div class="vx-col w-full md:w-1/2">
                  <DataInput
                    v-model="cvForm.dateUntil"
                    required
                    type="date-dropdown"
                    class="w-full mt-4"
                    label="Datum bis"
                    name="dateUntil"
                  />
                </div>
              </template>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/2">
                <DataInput
                  v-model="cvForm.type"
                  required
                  type="model"
                  class="w-full mt-4"
                  label="Typ"
                  name="type"
                  gql-query="applicantCvEntryTypes"
                  validation-rules="required"
                />
              </div>
              <div class="vx-col w-full md:w-1/2">
                <DataInput
                  v-model="cvForm.employer"
                  class="w-full mt-4"
                  label="Wo? (Arbeitgeber / Schule)"
                  name="employer"
                />
              </div>
              <div class="vx-col w-full md:w-1/2">
                <DataInput
                  v-model="cvForm.branch"
                  type="model"
                  class="w-full mt-4 "
                  label="Branche"
                  name="branch"
                  gql-query="applicantCvEntryBranches"
                />
              </div>
              <div class="vx-col w-full md:w-1/2">
                <DataInput
                  v-model="cvForm.position"
                  class="w-full mt-4"
                  label="Was? (Position / Abschluss)"
                  name="position"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <DataInput
                  v-model="cvForm.description"
                  type="html"
                  class="w-full mt-4"
                  label="Beschreibung / Sonstiges"
                  name="description"
                />
              </div>
              <div class="vx-col w-full">
                <vs-button
                  v-if="editing === null"
                  class="mt-4"
                  @click="addCvEntry"
                  >Hinzufügen</vs-button
                >
                <vs-button v-else class="mt-4" @click="saveCvEntry"
                  >Speichern</vs-button
                >
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import draggable from "vuedraggable";

export default {
  components: {
    DataInput,
    draggable
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    cvForm: {
      dateFrom: null,
      dateUntil: null,
      type: null,
      position: null,
      employer: null,
      branch: null,
      description: null
    },
    currentJob: false,
    oldDateUntil: null,
    updating: false,
    internalValue: null,
    monthPickerConfig: {
      altInput: true,
      plugins: [new monthSelect({ dateFormat: "Y-m-01", altFormat: "m.Y" })]
    },
    editing: null,
    descriptionOpen: null
  }),
  /*
  computed: {
    internalValue: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  */
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (!this.updating) {
          this.internalValue = v;
        }
      }
    },
    currentJob(value) {
      if (value) {
        this.oldDateUntil = this.cvForm.dateUntil;
        this.cvForm.dateUntil = null;
      } else {
        this.cvForm.dateUntil = this.oldDateUntil;
      }
    }
  },
  methods: {
    formatTimeframe(dateFrom, dateUntil) {
      let getDateString = date => {
        date = date.split("-").reverse();

        if (date.length === 3) {
          if (+date[1] === 0) {
            return date[2];
          }
        }

        date.splice(0, 1);
        return date.join("/");
      };

      if (!dateUntil) {
        return "seit " + getDateString(dateFrom);
      }

      return `${getDateString(dateFrom)} - ${getDateString(dateUntil)}`;
    },
    async addCvEntry() {
      let currentEntry = JSON.parse(JSON.stringify(this.cvForm));

      if (currentEntry.currentJob) {
        currentEntry.dateUntil = undefined;
      }

      currentEntry.currentJob = undefined;
      this.internalValue = this.internalValue.concat([currentEntry]);
      let result = await this.$refs.Cv.validate();

      if (result == true) {
        this.$emit("add-entry", currentEntry);
        setTimeout(() => {
          this.cvForm = {
            dateFrom: null,
            dateUntil: null,
            type: null,
            position: null,
            employer: null,
            branch: null,
            description: null
          };
        }, 50);
      }
    },
    saveCvEntry() {
      this.$set(this.internalValue, this.editing, this.cvForm);
      this.$emit("update-entry", this.cvForm);
      this.editing = null;

      this.cvForm = {
        dateFrom: null,
        dateUntil: null,
        type: null,
        position: null,
        employer: null,
        branch: null,
        description: null
      };
    },
    editEntry(id, data) {
      this.editing = id;
      if (!data.dateUntil) {
        this.currentJob = true;
      }
      this.cvForm = JSON.parse(JSON.stringify(data));
    },
    deleteEntry(id, data) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei, einen Eintrag zu löschen. Möchtest du diese wirklich löschen?`,
        accept: () => {
          this.$apollo
            .mutate({
              mutation: gql`
                mutation($id: ID!) {
                  deleteCvEntry(id: $id) {
                    id
                  }
                }
              `,
              variables: {
                id: data.id
              }
            })
            .then(() => {
              this.$emit("refetch");
            });
        },
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    sortEntries() {
      this.$emit("sort-entries");
    },
    onSort(e) {
      this.updating = true; // TODO: Fix workaround
      const newIndex = e.newIndex;
      let newSortVal = this.internalValue[newIndex].sort;
      if (newIndex > 0) {
        const sortValBefore = this.internalValue[newIndex - 1].sort;

        newSortVal = +sortValBefore + 10;
      } else {
        newSortVal = 10;
      }

      this.internalValue[newIndex].sort = newSortVal;
      if (this.internalValue.length > newIndex) {
        let lastSortVal = newSortVal;
        for (let i in this.internalValue) {
          if (i < newIndex) {
            continue;
          }

          if (lastSortVal > this.internalValue[i].sort) {
            lastSortVal++;
            this.internalValue[i].sort = lastSortVal;
            this.$emit("update-entry", this.internalValue[i]);
          }
        }
      }
      this.$emit("update-entry", this.internalValue[newIndex]);

      // TODO: Fix workaround
      setTimeout(() => {
        this.updating = false;
      }, 500);
    },
    openDescription(i) {
      if (this.descriptionOpen == i) {
        this.descriptionOpen = null;
      } else {
        this.descriptionOpen = i;
      }
    }
  }
};
</script>
